import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import Area from '@/components/apps/layouts/shared/Area';
import SectionTitle from '@/components/apps/ui/title/SectionTitle';

import { useIndustrialSoundChips } from '../useIndustrialPageData';
import IndustrialSampleShowcase from './IndustrialSampleShowcase';

const CHIP_BASE_CLASS =
  'inline-flex min-h-[45px] max-w-full items-center whitespace-nowrap rounded-[48px] px-5 py-0 text-[18px] leading-[1.4] lg:min-h-[56px] lg:px-7 lg:text-[20px]';

// highlighted 값에 따라 background / color / font-weight 세 속성이 함께 바뀐다.
// 유틸리티가 모두 !important 이므로 같은 속성이 두 번 나오지 않도록
// 분기 결과를 JS 에서 미리 계산해 속성당 클래스 하나만 내보낸다.
const CHIP_VARIANT_CLASS = {
  on: 'bg-apps-coreGrayWhite font-bold text-apps-coreGrayBlack',
  off: 'bg-apps-coreGray01 font-medium text-apps-coreGray06',
} as const;

export default function IndustrialSoundSection() {
  const { t } = useTranslation('common');
  const chips = useIndustrialSoundChips(t);

  return (
    <section
      className="pt-[clamp(100px,10.417vw,200px)]"
      data-analytics-section="sound_samples"
    >
      <Area>
        <SectionTitle
          color="lighter"
          title={t('감지 가능한 주요 사운드')}
          description={t(
            '디플리 Listen AI는 공장, 발전소 등 산업 시설에서 발생하는 다양한 소리를 듣고 분석할 수 있어요.',
          )}
        />
        <ul className="mt-10 flex flex-wrap gap-3 lg:mt-[clamp(40px,5vw,60px)] lg:gap-4">
          {chips.map((chip, index) => (
            <li key={index}>
              <span
                className={`${CHIP_BASE_CLASS} ${
                  chip.highlighted
                    ? CHIP_VARIANT_CLASS.on
                    : CHIP_VARIANT_CLASS.off
                }`}
              >
                {chip.label}
              </span>
            </li>
          ))}
        </ul>

        <IndustrialSampleShowcase t={t} />
      </Area>
    </section>
  );
}
